import { Body, Button, Modal } from "@indigo-components";
import { useAtom } from "jotai";
import { outOfSyncAtom } from "~/atoms/outOfSync";
import { OUT_OF_SYNC_MESSAGE, OUT_OF_SYNC_TITLE } from "./outOfSyncCopy";

function reload() {
  window.location.reload();
}

/**
 * Shown when this tab is running an older deploy than what's live and a lazy
 * chunk failed to load (see services/chunkLoadRecovery.ts). Non-destructive:
 * the user can dismiss to save work in the current page, then reload manually.
 * Mounted once near the app root.
 */
export function OutOfSyncModal() {
  const [outOfSync, setOutOfSync] = useAtom(outOfSyncAtom);

  return (
    <Modal
      open={outOfSync}
      title={OUT_OF_SYNC_TITLE}
      centered
      maskClosable={false}
      onCancel={() => setOutOfSync(false)}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="md" onClick={() => setOutOfSync(false)}>
            Not now
          </Button>
          <Button variant="primary" size="md" onClick={reload}>
            Reload
          </Button>
        </div>
      }
    >
      <Body size="md" className="text-[var(--indigo-text-secondary)]">
        {OUT_OF_SYNC_MESSAGE}
      </Body>
    </Modal>
  );
}
